import React, { useState } from 'react';
import support from "./img/headset.png";
import form from "./img/formulario_asistencia.svg"

interface ButtonHelpDeskProps {
    messages: any
}

const ButtonHelpDesk = (props: ButtonHelpDeskProps) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <>
            <button
                type="button"
                className="btn floating-btn"
                onClick={handleShow}
            >
                <img className="logo_btn justify-content-center" src={support}/>
            </button>

            <div className={`modal fade ${show ? 'show d-block' : 'd-none'}`} onClick={handleClose}>
                <div className="modal-dialog" onClick={e => e.stopPropagation()}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">formulario de asistencia</h5>
                            <button type="button" className="btn-close me-2" aria-label="Close" onClick={handleClose}></button>
                        </div>
                        <div className="modal-body justify-content-center text-left">
                        <div className="modal-dialog-centered ms-2">
                                <img src={form} className="img-asistencia me-2"/>
                                <p className={"m-0"}>Click aquí para ingresar al&nbsp;
                                    <a className={"text-break"} target={"_blank"} href="https://evoting.typeform.com/to/VKwDaENo">
                                        formulario de asistencia
                                    </a>
                                </p>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={handleClose}>Cerrar</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ButtonHelpDesk;